import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Comment from '../../../../common/comments/comment.component';
import { MAX_LENGTH } from '../../../../../constants/external-constants'
import { Loading } from '../../../../../components/common/loading';
import { orderDetailsCommentsActions } from "../../../../../store/external/order/order-details-comments.reducer";

class OrderCommentsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        }

    }

    componentDidMount() {
        const { getOrderDetailsComments, orderDetailsId, getQuotationDetailsComments, quotationRequestId, orderDetailsComments } = this.props;
        if (orderDetailsId != null) {
            getOrderDetailsComments(orderDetailsId, orderDetailsComments?.commentsPage)
                .then(() => {
                    this.setState({ isLoading: false })
                });
        }
        else {
            getQuotationDetailsComments(quotationRequestId, orderDetailsComments?.commentsPage)
                .then(() => {
                    this.setState({ isLoading: false })
                });
        }       
    }

    postComment(attachedFilename, attachedFileData, commentDescription) {
        const { postOrderDetailsComments, orderDetailsId, postQuotationDetailsComments, quotationRequestId } = this.props;

        if (orderDetailsId != null) {
            postOrderDetailsComments(orderDetailsId, attachedFilename, attachedFileData, commentDescription)
                .then(() => {
                    this.setState({ isLoading: false })
                });
        }
        else {
            postQuotationDetailsComments(quotationRequestId, attachedFilename, attachedFileData, commentDescription)
                .then(() => {
                    this.setState({ isLoading: false })
                });
        }
    }

    handleDeleteOrderDetailsComments = async (orderDetailsCommentID) => {
        this.setState({ isLoading: true });
        const { getOrderDetailsComments, deleteOrderDetailsComments, orderDetailsId, getQuotationDetailsComments, deleteQuotationDetailsComments, quotationRequestId, orderDetailsComments, resetOrderCircuitComments, resetQuotationCircuitComments } = this.props;

        if (orderDetailsId != null) {
            await deleteOrderDetailsComments(orderDetailsCommentID, orderDetailsId);
            await resetOrderCircuitComments();
            await getOrderDetailsComments(orderDetailsId, 1, orderDetailsComments?.OrderDetailsComments?.length).then(() => {
                this.setState({ isLoading: false })
            });
            this.setState({ show: false })
        }
        else {
            await deleteQuotationDetailsComments(orderDetailsCommentID, quotationRequestId);
            await resetQuotationCircuitComments();
            await getQuotationDetailsComments(quotationRequestId, 1, orderDetailsComments?.OrderDetailsComments?.length).then(() => {
                this.setState({ isLoading: false })
            });
            this.setState({ show: false })
        }
    }

    handleLoadMore = async () => {
        const { getOrderDetailsComments, getQuotationDetailsComments, orderDetailsComments, orderDetailsId, quotationRequestId } = this.props;
        if (orderDetailsId != null) {
            await getOrderDetailsComments(orderDetailsId, orderDetailsComments.commentsPage + 1)
        }
        else {
            await getQuotationDetailsComments(quotationRequestId, orderDetailsComments.commentsPage + 1)
        }

    }

    cleanComments = (comments = []) => {
        return comments.map(comment => ({
            ...comment,
            Comment: typeof comment.Comment === "string"
                ? comment.Comment.replace(/\s+of the analyst(?=\s|$)/gi, "")
                : comment.Comment
        }));
    };

    componentWillUnmount() {
        const { resetOrderCircuitComments, resetQuotationCircuitComments, orderDetailsId } = this.props;
        if (orderDetailsId != null) {
            resetOrderCircuitComments();
        }
        else {
            resetQuotationCircuitComments();
        }
    }

    render() {
        const { orderDetailsComments, orderDetailsId, quotationRequestId } = this.props;
        if (this.state.isLoading) {
            return <Loading />
        }
        return (
            <>
                <Comment
                    commentList={this.cleanComments(orderDetailsComments.OrderDetailsComments || [])}
                    addCommentAction={this.postComment.bind(this)}
                    deleteCommentAction={this.handleDeleteOrderDetailsComments.bind(this)}
                    maxLength={MAX_LENGTH.limit_500}
                    isOrderDetailsComment={orderDetailsId != null ? true : false}
                    isQuotationDetailsComment={quotationRequestId != null ? true : false}
                    handleLoadMore={this.handleLoadMore}
                    hasMoreComments={this.props?.orderDetailsComments?.hasMoreComments}
                    //Access Types
                    {...this.props.roles}
                />
            </>
        );
    }
}


export default connect(
    state => {
        const { orderDetailsComments } = state;

        return {
            orderDetailsComments
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, orderDetailsCommentsActions),
        dispatch
    )
)(OrderCommentsComponent);